export default function InteractiveMap(svg_map) {

	const departements = svg_map.querySelectorAll(".dep");
	const isPopoverSupported = supportsPopover();

	this.init = () => {
		departements.forEach((dep) => {
			this.addButtonAttributes(dep);

			this.configureNuance(dep);

		});
	}

	this.addButtonAttributes = (elt) => {
		let numDep = elt.getAttribute('id').split('_')[1];
		let popover = document.querySelector(`#popover_${numDep}`);
		elt.setAttribute("role", "button");
		elt.setAttribute("tabindex", "0");

		if (isPopoverSupported) {
			elt.setAttribute('aria-labelledby', `popover_${numDep}_title`);
			if (popover) {
				this.handleButton(elt, popover);
			}

		} else {
			elt.setAttribute('aria-labelledby', `popover_${numDep}_content`);
		}
	}

	this.configureNuance = (dep) => {
		const numDep = dep.getAttribute('id').split('_')[1];
		const nb = parseInt(document.querySelector(`.map_d_${numDep}`).textContent || 0);
		let d_class;

		if (nb >= 0 && nb < 100) {
			d_class = "st0";
		} else if (nb >= 100 && nb < 200) {
			d_class = "st1";
		} else if (nb >= 200 && nb < 500) {
			d_class = "st2";
		} else if (nb >= 500 && nb < 1000) {
			d_class = "st3";
		} else if (nb >= 1000) {
			d_class = "st4";
		}

		if (dep.nodeName === 'path') {
			dep.classList.remove("st0", "st1", "st2");
			dep.classList.add(d_class);
		} else if (dep.nodeName === 'g') {
			const paths = dep.querySelectorAll('path');
			paths.forEach((path) => {
				path.classList.remove("st0", "st1", "st2");
				path.classList.add(d_class);
			});
		}

	}

	this.handleButton = (button, popover) => {

		button.addEventListener('click', () => {
			popover.showPopover();
			popover.focus();
		});

		button.addEventListener("keydown", function (e) {
			// enter key
			if (e.keyCode === 13) {
				popover.showPopover();
				popover.focus();
			}

			if (e.keyCode === 32) {
				e.preventDefault();
			}

		});

		button.addEventListener("keyup", function (e) {
			// space key
			if (e.keyCode === 32) {

				popover.showPopover();
				popover.focus();

			}
		});
	}
}

function supportsPopover() {
	return Object.hasOwn(HTMLElement.prototype, "popover");
}